var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-container"},[_c('transition-group',{attrs:{"name":"list","tag":"div"}},_vm._l((_vm.notifications),function(notification,index){return _c('div',{key:notification[_vm.idProp],staticClass:"item-wrapper",style:(_vm.inlineStyles(index + 1))},[_vm._t("default",null,{"notification":notification})],2)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }